/**
 * Styled Components - Created by jorge on 01/08/18.
 */
import styled from 'styled-components'

export const Container = styled.div`
  background-color: #fff;
  display: flex;
  justify-content: center;
  flex-flow: column;
  align-items: center;
  height: 100vh;
  width: 100%;
`

export const JakrooLogo = styled.img`
  max-width: 239px;
  width: 100%;
  margin-bottom: 32px;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/GetMeasured/styledComponents.tsx